import { createFileRoute } from '@tanstack/react-router';

import { AnalyticsPage } from '@frontend/features/analytics/components/AnalyticsPage';

export const Route = createFileRoute('/analytics/')({
  component: AnalyticsPage,
});
